import { createContext } from 'react';
import type { Location } from '@/modules/location/types/location.contract';

export type UserLocation = Location;

export type User = {
  id: string;
  phone: string;
  name: string;
  email?: string;
  avatar: string;
};

export type UserMethods = {
  clean: () => void;
  save: (user: User) => void;
  update: (user: Partial<User>) => void;
  get: () => User | null;
};

export type UserContextProps = {
  user: UserMethods;
};

export const UserContext = createContext<UserContextProps>({} as UserContextProps);
